import React from 'react';
import PropTypes from 'prop-types';

import style from './Textarea.module.css';

const Textarea = React.memo(({ name, value, styles = {}, onChange }) => {
  return (
    <textarea
      name={name}
      id={name}
      style={styles}
      className={style.textarea}
      value={value}
      onChange={onChange}
    />
  );
});

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  styles: PropTypes.shape({}),
};

export default Textarea;
